exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".invalid td[data-v-7043ea4a]{background-color:#ffd178!important;color:#000!important}.has-chosen td[data-v-7043ea4a]{background-color:#557c84!important;color:#fff!important}", "", {"version":3,"sources":["F:/myugfront/src/pages/medicine-lab-groups.vue"],"names":[],"mappings":"AACA,6BACE,mCAAqC,AACrC,oBAAuB,CACxB,AACD,gCACE,mCAAqC,AACrC,oBAAuB,CACxB","file":"medicine-lab-groups.vue","sourcesContent":["\n.invalid td[data-v-7043ea4a] {\n  background-color: #ffd178 !important;\n  color: #000 !important;\n}\n.has-chosen td[data-v-7043ea4a] {\n  background-color: #557C84 !important;\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7043ea4a","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/medicine-lab-groups.vue
// module id = 1173
// module chunks = 25